<template>
  <div class="full-screen-overlay" :class="{'full-screen-overlay--init': initializing}">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'FullScreenOverlay',
  props: {
    initializing: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    document.body.appendChild(this.$el)
  },
  destroyed() {
    // in certain scenarios, e.g. back button click, the overlay may not get removed from the DOM so we ensure to remove it as a safeguard
    if (document.body.contains(this.$el)) {
      document.body.removeChild(this.$el)
    }
  }
}
</script>

<style scoped lang="less">
@media screen {
  .full-screen-overlay {
    @easeFunction: cubic-bezier(0.215, 0.61, 0.355, 1);
    @easeDuration: 0.5s;
    transition: top @easeDuration @easeFunction, left @easeDuration @easeFunction,
      right @easeDuration @easeFunction, bottom @easeDuration @easeFunction,
      width @easeDuration @easeFunction;
    position: fixed;
    z-index: 11111111;
    left: 24px;
    top: 24px;
    bottom: 24px;
    right: 24px;
    /*width: 100%;*/
    background: white;
    overflow: auto;
    box-shadow: 0 0 24px 2px rgba(0, 0, 0, 0.3);
  }
  .full-screen-overlay--init {
    top: 150px;
    left: ~'calc(50% - 100px)';
    right: ~'calc(50% - 100px)';
    width: 200px;
    bottom: unset;
    overflow: hidden;
    border-radius: 32px;
  }
}
</style>
